import React, { useEffect, useState } from "react";
import { Field, FieldArray, Formik } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import Breadcrums from "../../../common/breadcrumbs";
import {
    blockInvalidChar,
    getNameFromList,
    handleServerValidations,
    hasPermission,
} from "../../../../../utils/commonfunction";
import {
    SWAL_SETTINGS,
    isProfileRequired,
} from "../../../../../utils/Constants";
import { TagPicker, Toggle } from "rsuite";
import CustomCkeditor from "../../../common/customeditor";
import ReactCountryFlag from "react-country-flag";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import Loader from "../../../common/loader";
import { useDispatch } from "react-redux";
import { fetchDetailsApi } from "../../../../../redux/slices/globalDetails";

const GlobalCommonSettings = (props) => {
    const dispatch = useDispatch()
    const [showdefault, setShowDefault] = useState({});
    const [contactNumber, setContactNumber] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);
    const breadcrumbs = [
        { title: "Dashboard", url: "/admin/dashboard" },
        { title: "Global Settings", url: "" },
    ];
    const [previewimage, setPreviewImage] = useState("");
    const [previewImageGerman, setPreviewImageGerman] = useState("");

    useEffect(() => {
        globalSettingsService
            .Details()
            .then((response) => {
                setShowDefault(response && response.data ? response.data : []);
                setPreviewImage(response.data.login_bg_image);
                setPreviewImageGerman(response.data.login_bg_image_de);
                setContactNumber(JSON.parse(response?.data?.contact_no));
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
                setDataLoaded(true);
            });
    }, []);

    return (
        <>
            {/* <Breadcrums data={breadcrumbs} /> */}
            {dataLoaded ? (
                <Formik
                    validateOnChange={true}
                    enableReinitialize
                    initialValues={{
                        activity_forum: showdefault && showdefault.activity_forum ? showdefault.activity_forum : false,
                        single_language: showdefault && showdefault.single_language ? showdefault.single_language : false,
                        announcement: showdefault && showdefault.announcement ? showdefault.announcement : false,
                        surveys: showdefault && showdefault.surveys ? showdefault.surveys : false,
                        internal_chat: showdefault && showdefault.internal_chat ? showdefault.internal_chat : false,
                        comments: showdefault && showdefault.comments ? showdefault.comments : false,
                        enable_lead_management: showdefault && showdefault.enable_lead_management ? showdefault.enable_lead_management : false,
                        enable_sis_management: showdefault && showdefault.enable_sis_management ? showdefault.enable_sis_management : false,
                        socialMedia:
                            showdefault && showdefault.social_media
                                ? showdefault.social_media
                                : [],
                        dietary_requirement: showdefault && showdefault.dietary_requirement ? showdefault.dietary_requirement : false,
                        // Address:
                        //   showdefault && showdefault.address ? showdefault.address : "",
                        // smtp_username:
                        //   showdefault && showdefault.smtp_username
                        //     ? showdefault.smtp_username
                        //     : "",
                        // AdminEmail:
                        //   showdefault && showdefault.admin_email
                        //     ? showdefault.admin_email
                        //     : "",
                        // Contact:
                        //   contactNumber && contactNumber?.number
                        //     ? contactNumber?.number
                        //     : "",
                        // countryCodePhone:
                        //   contactNumber && contactNumber?.countryCode
                        //     ? contactNumber?.countryCode
                        //     : "",
                        // dialCodePhone:
                        //   contactNumber && contactNumber?.code
                        //     ? contactNumber?.code
                        //     : "" + getCountryCallingCode(getCountries()[0]),
                        // TermsAndConditionTwo:
                        //   showdefault && showdefault.terms_and_condition_two
                        //     ? showdefault.terms_and_condition_two
                        //     : "",
                        // TermsAndConditionOne:
                        //   showdefault && showdefault.terms_and_condition_one
                        //     ? showdefault.terms_and_condition_one
                        //     : "",
                        // TermsAndConditionTwoDe:
                        //   showdefault && showdefault.terms_and_condition_two_de
                        //     ? showdefault.terms_and_condition_two_de
                        //     : "",
                        // TermsAndConditionOneDe:
                        //   showdefault && showdefault.terms_and_condition_one_de
                        //     ? showdefault.terms_and_condition_one_de
                        //     : "",
                        // richtext:
                        //   showdefault && showdefault.login_content
                        //     ? showdefault.login_content
                        //     : "",
                        // richtext_de:
                        //   showdefault && showdefault.login_content_de
                        //     ? showdefault.login_content_de
                        //     : "",
                        // footer_text:
                        //   showdefault && showdefault.footer_text
                        //     ? showdefault.footer_text
                        //     : "",
                        // CopyRighttxt:
                        //   showdefault && showdefault.copy_right_text
                        //     ? showdefault.copy_right_text
                        //     : "",
                        // login_bg_image: showdefault && showdefault.login_bg_image ? showdefault.login_bg_image : "",
                        // login_bg_image_de: showdefault && showdefault.login_bg_image_de ? showdefault.login_bg_image_de : "", 
                        // invoice_footer:
                        //     showdefault && showdefault.invoice_footer
                        //         ? showdefault.invoice_footer
                        //         : "",
                        // web: showdefault && showdefault.website ? showdefault.website : "",
                        // ticket_prefix_text:
                        //     showdefault && showdefault.ticket_prefix_text
                        //         ? showdefault.ticket_prefix_text
                        //         : "",
                        // ticket_prefix_number:
                        //     showdefault && showdefault.ticket_prefix_number
                        //         ? showdefault.ticket_prefix_number
                        //         : "",
                        // ticket_footer_text:
                        //     showdefault && showdefault.ticket_footer_text
                        //         ? showdefault.ticket_footer_text
                        //         : "",
                        // cookies_content:
                        //     showdefault && showdefault.cookies_content
                        //         ? showdefault.cookies_content
                        //         : "",
                        // cookies_content_de:
                        //     showdefault && showdefault.cookies_content_de
                        //         ? showdefault.cookies_content_de
                        //         : "",
                        // default_language:
                        //     showdefault && showdefault.default_language
                        //         ? showdefault.default_language
                        //         : "",
                        // profile_required_fields:
                        //     showdefault && showdefault.profile_required_fields
                        //         ? showdefault.profile_required_fields
                        //         : "",
                        // pay_by_invoice_content:
                        //     showdefault && showdefault.pay_by_invoice_content
                        //         ? showdefault.pay_by_invoice_content
                        //         : "",
                    }}
                    validate={(values) => {
                        let error = { socialMedia: [] };
                        if (values.socialMedia.length > 0) {
                            values.socialMedia.forEach((element, i) => {
                                error.socialMedia[i] = {};
                                if (!element.title) {
                                    error.socialMedia[i]["title"] = "Title is required";
                                }
                                if (!element.url) {
                                    error.socialMedia[i]["url"] = "URL is required";
                                }
                                if (!element.icon) {
                                    error.socialMedia[i]["icon"] = "Icon is required";
                                }
                            });
                        }
                        // if (!values.Address || !values.Address.trim())
                        //     error.Address = "Address is required";

                        // if (!values.smtp_username || !values.smtp_username.trim())
                        //     error.smtp_username = "SMTP Username is required";
                        // if (!values.AdminEmail) {
                        //     error.AdminEmail = "Email is required";
                        // }
                        // // else if (
                        // //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.AdminEmail)
                        // // ) {
                        // //   error.AdminEmail = "Invalid email address";
                        // // }
                        // else if (
                        //     !/^[A-Z0-9._%+'-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                        //         values.AdminEmail
                        //     )
                        // ) {
                        //     error.AdminEmail = "Invalid email address";
                        // }
                        // if (!values.Contact) {
                        //     error.Contact = "Contact is required";
                        // }
                        // if (!values.CopyRighttxt || !values.CopyRighttxt.trim()) {
                        //     error.CopyRighttxt = "Copy right text is required";
                        // }
                        // if (
                        //     !values.TermsAndConditionTwo ||
                        //     !values.TermsAndConditionTwo.trim()
                        // ) {
                        //     error.TermsAndConditionTwo =
                        //         "Terms and condition text is required";
                        // }
                        // if (
                        //     !values.TermsAndConditionOne ||
                        //     !values.TermsAndConditionOne.trim()
                        // ) {
                        //     error.TermsAndConditionOne =
                        //         "Terms and condition text is required";
                        // }
                        // if (!values.richtext || !values.richtext.trim()) {
                        //     error.richtext = "Login banner page text is required";
                        // }
                        // if (!values.footer_text || !values.footer_text.trim()) {
                        //     error.footer_text = "Footer text is required";
                        // }
                        // if (!values.invoice_footer || !values.invoice_footer.trim()) {
                        //     error.invoice_footer = "Invoice footer is required";
                        // }
                        // if (
                        //     !values.pay_by_invoice_content ||
                        //     !values.pay_by_invoice_content.trim()
                        // ) {
                        //     error.pay_by_invoice_content =
                        //         "Pay by invoice content is required";
                        // }
                        // if (
                        //     !values.ticket_prefix_text ||
                        //     !values.ticket_prefix_text.trim()
                        // ) {
                        //     error.ticket_prefix_text = "Ticket prefix text is required";
                        // }
                        // if (!values.ticket_prefix_number) {
                        //     error.ticket_prefix_number = "Ticket prefix number is required";
                        // }
                        // if (!values.ticket_footer_text) {
                        //     error.ticket_footer_text = "Ticket footer text is required";
                        // }
                        // if (!values.cookies_content) {
                        //     error.cookies_content = "Cookies content is required";
                        // }
                        // if (!values.default_language) {
                        //     error.default_language = "Default language is required";
                        // }
                        // // if (!values.profile_required_fields) {
                        // //   error.profile_required_fields = "This filed is required";
                        // // }
                        // if (!values.web) {
                        //     error.web = "Website is required";
                        // }
                        if (values.socialMedia.length > 0) {
                            values.socialMedia.forEach((element, i) => {
                                if (element.title && element.url && element.icon) {
                                    if (i === values.socialMedia.length - 1) {
                                        delete error.socialMedia;
                                    }
                                } else {
                                    return error;
                                }
                            });
                        } else {
                            delete error.socialMedia;
                        }
                        return error;
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setSubmitted(true);
                        let formData = new FormData();
                        // formData.append("address", values.Address);
                        // formData.append("website", values.web);
                        // formData.append("smtp_username", values.smtp_username);
                        // formData.append("admin_email", values.AdminEmail);
                        // if (values.Contact && values.dialCodePhone) {
                        //     formData.append(
                        //         "contact_no",
                        //         JSON.stringify({
                        //             code: values.dialCodePhone,
                        //             number: values.Contact,
                        //             countryCode: values.countryCodePhone,
                        //         })
                        //     );
                        // }
                        // formData.append("copy_right_text", values.CopyRighttxt);
                        // formData.append(
                        //     "terms_and_condition_one",
                        //     values.TermsAndConditionOne
                        // );
                        // formData.append(
                        //     "terms_and_condition_two",
                        //     values.TermsAndConditionTwo
                        // );
                        // formData.append(
                        //     "terms_and_condition_one_de",
                        //     values.TermsAndConditionOneDe
                        // );
                        // formData.append(
                        //     "terms_and_condition_two_de",
                        //     values.TermsAndConditionTwoDe
                        // );
                        // formData.append("login_content", values.richtext);
                        // formData.append("login_bg_image", values.login_bg_image);
                        // formData.append("login_bg_image_de", values.login_bg_image_de);
                        // formData.append("footer_text", values.footer_text);
                        formData.append("social_media", JSON.stringify(values.socialMedia));
                        formData.append("activity_forum", values.activity_forum);
                        // formData.append("single_language", values.single_language);
                        formData.append("announcement", values.announcement);
                        formData.append("surveys", values.surveys);
                        formData.append("internal_chat", values.internal_chat);
                        formData.append("comments", values.comments);
                        formData.append("enable_lead_management", values.enable_lead_management);
                        formData.append("enable_sis_management", values.enable_sis_management);
                        formData.append("dietary_requirement", values.dietary_requirement);
                        // formData.append("invoice_footer", values.invoice_footer);
                        // formData.append("ticket_prefix_text", values.ticket_prefix_text);
                        // formData.append(
                        //     "ticket_prefix_number",
                        //     values.ticket_prefix_number
                        // );
                        // formData.append("ticket_footer_text", values.ticket_footer_text);
                        // formData.append("cookies_content", values.cookies_content);
                        // formData.append("cookies_content_de", values.cookies_content_de);
                        // formData.append("default_language", values.default_language);
                        // formData.append(
                        //     "profile_required_fields",
                        //     JSON.stringify(values.profile_required_fields)
                        // );
                        // formData.append(
                        //     "pay_by_invoice_content",
                        //     values.pay_by_invoice_content
                        // );
                        // formData.append("login_content_de", values.richtext_de);
                        globalSettingsService
                            .Add(formData)
                            .then((response) => {
                                if (response.success) {
                                    Swal.fire({
                                        icon: "success",
                                        text: 'Global settings updated successfully',
                                        ...SWAL_SETTINGS,
                                    });
                                    setTimeout(() => {
                                        setSubmitted(false);
                                        dispatch(fetchDetailsApi());
                                    }, 2000);
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        text: handleServerValidations(response),
                                        ...SWAL_SETTINGS,
                                    });
                                    setSubmitted(false);
                                }
                            })
                            .catch((error) => {
                                console.log("error ====> ", error);
                            });
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                        setFieldTouched,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="row row-sm">
                                <div className="col-lg-12 col-md-12 animation_fade">
                                    <div className="card custom-card">
                                        <div className="">
                                            <div>
                                                {/* <h6 className="main-content-label mb-3">
                          Global Settings
                        </h6> */}
                                            </div>
                                            <div className="row row-sm">
                                                <div className="col-12">
                                                    <div
                                                        className={
                                                            "d-flex justify-content-between " +
                                                            (hasPermission(
                                                                "/admin/cms/settings/toggle/activity-forum"
                                                            )
                                                                ? ""
                                                                : "disable-input")
                                                        }
                                                        style={{ maxWidth: "200px" }}
                                                    >
                                                        <label
                                                            htmlFor="activity_forum"
                                                            className="text-left cp"
                                                        >
                                                            Activity forum
                                                        </label>

                                                        <Toggle
                                                            className="ms-3"
                                                            id="activity_forum"
                                                            name="activity_forum"
                                                            checked={values.activity_forum}
                                                            onChange={(e) => {
                                                                setFieldValue("activity_forum", e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div
                                                        className={
                                                            "d-flex justify-content-between " +
                                                            (hasPermission(
                                                                "/admin/cms/settings/toggle/announcement"
                                                            )
                                                                ? ""
                                                                : "disable-input")
                                                        }
                                                        style={{ maxWidth: "200px" }}
                                                    >
                                                        <label
                                                            htmlFor="announcement"
                                                            className="text-left cp"
                                                        >
                                                            Announcement
                                                        </label>

                                                        <Toggle
                                                            className="ms-3"
                                                            id="announcement"
                                                            name="announcement"
                                                            checked={values.announcement}
                                                            onChange={(e) => {
                                                                setFieldValue("announcement", e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div
                                                        className={
                                                            "d-flex justify-content-between " +
                                                            (hasPermission(
                                                                "/admin/cms/settings/toggle/activity-forum"
                                                            )
                                                                ? ""
                                                                : "disable-input")
                                                        }
                                                        style={{ maxWidth: "200px" }}
                                                    >
                                                        <label htmlFor="surveys" className="text-left cp">
                                                            Surveys
                                                        </label>
                                                        <Toggle
                                                            className="ms-3"
                                                            id="surveys"
                                                            name="surveys"
                                                            checked={values.surveys}
                                                            onChange={(e) => {
                                                                setFieldValue("surveys", e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div
                                                        className={
                                                            "d-flex justify-content-between " +
                                                            (hasPermission(
                                                                "/admin/cms/settings/toggle/activity-forum"
                                                            )
                                                                ? ""
                                                                : "disable-input")
                                                        }
                                                        style={{ maxWidth: "200px" }}
                                                    >
                                                        <label
                                                            htmlFor="internal_chat"
                                                            className="text-left cp"
                                                        >
                                                            Internal chat
                                                        </label>
                                                        <Toggle
                                                            className="ms-3"
                                                            id="internal_chat"
                                                            name="internal_chat"
                                                            checked={values.internal_chat}
                                                            onChange={(e) => {
                                                                setFieldValue("internal_chat", e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div
                                                        className={
                                                            "d-flex justify-content-between " +
                                                            (hasPermission(
                                                                "/admin/cms/settings/toggle/activity-forum"
                                                            )
                                                                ? ""
                                                                : "disable-input")
                                                        }
                                                        style={{ maxWidth: "200px" }}
                                                    >
                                                        <label htmlFor="comments" className="text-left cp">
                                                            Comments
                                                        </label>
                                                        <Toggle
                                                            className="ms-3"
                                                            id="comments"
                                                            name="comments"
                                                            checked={values.comments}
                                                            onChange={(e) => {
                                                                setFieldValue("comments", e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className={"d-flex justify-content-between " + (hasPermission('/admin/cms/settings/toggle/activity-forum') ? '' : 'disable-input')} style={{ 'maxWidth': '200px' }}>
                                                        <label htmlFor="enable_lead_management" className="text-left cp">
                                                            Lead Management
                                                        </label>
                                                        <Toggle
                                                            className="ms-3"
                                                            id="enable_lead_management"
                                                            name="enable_lead_management"
                                                            checked={values.enable_lead_management}
                                                            onChange={(e) => {
                                                                setFieldValue('enable_lead_management', e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className={"d-flex justify-content-between " + (hasPermission('/admin/cms/settings/toggle/activity-forum') ? '' : 'disable-input')} style={{ 'maxWidth': '200px' }}>
                                                        <label htmlFor="enable_sis_management" className="text-left cp">
                                                            SIS
                                                        </label>
                                                        <Toggle
                                                            className="ms-3"
                                                            id="enable_sis_management"
                                                            name="enable_sis_management"
                                                            checked={values.enable_sis_management}
                                                            onChange={(e) => {
                                                                setFieldValue('enable_sis_management', e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                    {/* <div className={"d-flex justify-content-between " + (hasPermission('/admin/cms/settings/toggle/activity-forum') ? '' : 'disable-input')} style={{ 'maxWidth': '200px' }}> */}
                                                {/* <div className="col-12">
                                                    <div className="d-flex justify-content-between " style={{ 'maxWidth': '200px' }}>
                                                        <label htmlFor="dietary_requirement" className="text-left cp">
                                                           Dietary Requirement
                                                        </label>
                                                        <Toggle
                                                            className="ms-3"
                                                            id="dietary_requirement"
                                                            name="dietary_requirement"
                                                            checked={values.dietary_requirement}
                                                            onChange={(e) => {
                                                                setFieldValue('dietary_requirement', e);
                                                            }}
                                                        />
                                                    </div>
                                                </div> */}
                                                <label className="text-left d-flex">Social Media:</label>
                                                <FieldArray
                                                    name="socialMedia"
                                                    render={(arrayHelper) => (
                                                        <div className="col-12 mb-4">
                                                            <div className="row">
                                                                {values.socialMedia &&
                                                                    values.socialMedia.length > 0 ? (
                                                                    values.socialMedia.map((item, index) => (
                                                                        <div className="col-12 " key={index}>
                                                                            <div className="w-100 p-2 bg-group">
                                                                                <div className="row">
                                                                                    <div className="col-md-3 text-center form-group mb-0">
                                                                                        <Field
                                                                                            className="form-control"
                                                                                            id="title"
                                                                                            name={`socialMedia[${index}].title`}
                                                                                            onChange={handleChange}
                                                                                            onBlur={handleBlur}
                                                                                            value={item.title}
                                                                                            placeholder="Title"
                                                                                        />
                                                                                        <span className="text-danger d-flex text-left">
                                                                                            {((touched.socialMedia &&
                                                                                                touched.socialMedia[index] &&
                                                                                                touched.socialMedia[index]
                                                                                                    .title) ||
                                                                                                submitClicked) &&
                                                                                                errors.socialMedia &&
                                                                                                errors.socialMedia[index] &&
                                                                                                errors.socialMedia[index].title}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-md-4 text-center form-group mb-0">
                                                                                        <Field
                                                                                            className="form-control"
                                                                                            id="url"
                                                                                            name={`socialMedia[${index}].url`}
                                                                                            onChange={handleChange}
                                                                                            onBlur={handleBlur}
                                                                                            value={item.url}
                                                                                            placeholder="URL"
                                                                                        />
                                                                                        <span className="text-danger d-flex text-left">
                                                                                            {((touched.socialMedia &&
                                                                                                touched.socialMedia[index] &&
                                                                                                touched.socialMedia[index]
                                                                                                    .url) ||
                                                                                                submitClicked) &&
                                                                                                errors.socialMedia &&
                                                                                                errors.socialMedia[index] &&
                                                                                                errors.socialMedia[index].url}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-md-3 text-center form-group mb-0">
                                                                                        <Field
                                                                                            className="form-control"
                                                                                            id="icon"
                                                                                            name={`socialMedia[${index}].icon`}
                                                                                            onChange={handleChange}
                                                                                            onBlur={handleBlur}
                                                                                            value={item.icon}
                                                                                            placeholder="Icon"
                                                                                        />
                                                                                        <span className="text-danger d-flex text-left">
                                                                                            {((touched.socialMedia &&
                                                                                                touched.socialMedia[index] &&
                                                                                                touched.socialMedia[index]
                                                                                                    .icon) ||
                                                                                                submitClicked) &&
                                                                                                errors.socialMedia &&
                                                                                                errors.socialMedia[index] &&
                                                                                                errors.socialMedia[index].icon}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-md-2">
                                                                                        <div className="social-media-action">
                                                                                            <button
                                                                                                className="btn btn-danger "
                                                                                                type="button"
                                                                                                onClick={() =>
                                                                                                    arrayHelper.remove(index)
                                                                                                } // remove a friend from the list
                                                                                            >
                                                                                                Remove
                                                                                            </button>
                                                                                            {index ===
                                                                                                values?.socialMedia?.length -
                                                                                                1 && (
                                                                                                    <button
                                                                                                        className="btn btn-main-primary signbtn ms-2 "
                                                                                                        type="button"
                                                                                                        onClick={() =>
                                                                                                            arrayHelper.insert(
                                                                                                                values?.socialMedia
                                                                                                                    ?.length,
                                                                                                                {
                                                                                                                    title: "",
                                                                                                                    url: "",
                                                                                                                    icon: "",
                                                                                                                }
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        Add
                                                                                                    </button>
                                                                                                )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-main-primary signbtn mr-2 ms-2 mb-3"
                                                                        type="button"
                                                                        onClick={() => arrayHelper.push({})}
                                                                    >
                                                                        Add a social media
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                />
                                                {hasPermission("/admin/cms/settings/submit") ? (
                                                    <div className="">
                                                        <button
                                                            className="btn btn-main-primary signbtn mr-2"
                                                            type="submit"
                                                            disabled={submitted ? true : null}
                                                            onClick={() => {
                                                                setSubmitClicked(true);
                                                            }}
                                                        >
                                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                            Submit
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            ) : (
                <Loader />
            )}
        </>
    );
};

export default GlobalCommonSettings;
